module.exports = __webpack_public_path__ + "static/img/m_role.f884a79.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/tysdags/m_role.png
// module id = 4zuU
// module chunks = 7